export default {
    privacy_documents: {
        name: "Privacy Documents",
        value: "privacy_documents"
    },
    identity_documents: {
        name: "Identity Documents",
        value: "identity_documents"
    }
};
